module.exports = "<template> <stop-sale-set value.two-way=field.value field.bind=field></stop-sale-set> </template> ";